@if(userInstance?.type === 'WORKSPACE') {
<app-header-workspace [userInstance]="userInstance"></app-header-workspace>
} @else {
<app-header-global [userInstance]="userInstance"></app-header-global>
}
